import { LadderSvg } from "components/decorative/ladder-svg";
import { useCurrentCategory } from "lib/hooks/use-current-category";
import Link from "next/link";
import { FC, useState } from "react";
import { CategoriesForBrowse } from "./types";

type Props = {
  isBasePath: boolean;
  categories: CategoriesForBrowse;
};

export const CategoryNav: FC<Props> = ({ categories, isBasePath }) => {
  const [showCategories, setShowCategories] = useState<boolean>(true);
  const currentCategory = useCurrentCategory();
  const sortedCategories = [...categories];

  sortedCategories.some(
    (a, i) =>
      a.slug === "social-justice" &&
      sortedCategories.unshift(sortedCategories.splice(i, 1)[0])
  );

  return (
    <>
      <nav className='bg-green-light py-4 lg:py-8 relative w-full md:w-min overflow-x-hidden row-start-2 '>
        <h2 className='header text-2xl md:text-4xl text-white text-center pb-4 duration-1000'>
          Browse Categories
        </h2>

        {showCategories && (
          <button
            onClick={() => setShowCategories(!showCategories)}
            className='md:hidden flex flex-col mx-auto text-white hover:text-yellow-light pb-4'>
            {showCategories ? (
              <svg
                className=' w-8 h-8 mx-auto'
                xmlns='http://www.w3.org/2000/svg'
                fill='none'
                viewBox='0 0 24 24'
                stroke='currentColor'>
                <path
                  strokeLinecap='round'
                  strokeLinejoin='round'
                  strokeWidth={2}
                  d='M5 11l7-7 7 7M5 19l7-7 7 7'
                />
              </svg>
            ) : (
              <svg
                className=' w-8 h-8 mx-auto'
                xmlns='http://www.w3.org/2000/svg'
                fill='none'
                viewBox='0 0 24 24'
                stroke='currentColor'>
                <path
                  strokeLinecap='round'
                  strokeLinejoin='round'
                  strokeWidth={2}
                  d='M19 13l-7 7-7-7m14-8l-7 7-7-7'
                />
              </svg>
            )}
            <span className='mx-auto header  pt-2'>
              {showCategories ? "Hide" : "Show"}
            </span>
          </button>
        )}

        <ul
          className={`${
            showCategories ? "flex" : "hidden"
          } md:flex flex-col -ml-6 md:ml-auto md:pl-12 md:pr-16 pb-6 space-y-2`}>
          <li
            className={` transform translate-x-2 w-64 text-center mx-auto inline-flex  relative`}>
            <Link href='/browse'>
              <a
                onClick={() => setShowCategories(false)}
                className={`h-full w-full font-header tracking-wide uppercase cursor-pointer px-2 pt-1 md:text-xl ${
                  isBasePath ? "bg-yellow-default" : "bg-white"
                } hover:bg-yellow-default  rounded inline-flex`}>
                <span className='m-auto w-1/2'>All Categories</span>
              </a>
            </Link>
            <div
              className={`${
                !isBasePath && "hidden"
              } absolute -right-9 bottom-0 w-8 bg-white h-5 rounded-l-sm`}>
              <div className='float-right -mr-2 bg-green-light h-5 w-5 transform rotate-45'></div>
            </div>
          </li>
          {sortedCategories.map((c, index) => {
            const isSelected = currentCategory === c.slug;
            let indent = 0;

            if ((index + 1) % 2 === 0) {
              indent = 2;
            }
            if ((index + 1) % 4 === 0) {
              indent = 4;
            }
            if ((index + 1) % 5 === 0) {
              indent = 6;
            }

            return (
              <li
                key={c.slug}
                className={`transform translate-x-${indent} w-64 text-center mx-auto inline-flex relative`}>
                <Link href={`/browse/${c.slug}`}>
                  <a
                    onClick={() => setShowCategories(false)}
                    className={`h-full w-full font-header tracking-wide uppercase cursor-pointer px-2 pt-1 md:text-xl ${
                      isSelected ? "bg-yellow-default" : "bg-white"
                    } hover:bg-yellow-default rounded inline-flex`}>
                    <span className=' m-auto w-1/2'>{c.name}</span>
                  </a>
                </Link>
                <div
                  className={`${
                    !isSelected && "hidden"
                  } absolute -right-9 bottom-0 w-8 bg-white h-5 rounded-l-sm`}>
                  <div className='float-right -mr-2 bg-green-light h-5 w-5 transform rotate-45'></div>
                </div>
              </li>
            );
          })}
        </ul>
        <LadderSvg className='w-10 -right-4 ml-auto mr-16 -mt-14 absolute hidden md:block' />
        {!showCategories && (
          <div className=' md:hidden relative w-64 mx-auto mb-4'>
            <div
              className={`h-full w-full font-header tracking-wide uppercase cursor-pointer px-2 pt-1 md:text-xl bg-yellow-default inline-flex rounded`}>
              <span className=' m-auto'>
                {isBasePath ? "Browsing All" : currentCategory}
              </span>
            </div>
            <div
              className={`absolute -right-9 bottom-0 w-8 bg-white h-5 rounded-l-sm`}>
              <div className='float-right -mr-2 bg-green-light h-5 w-5 transform rotate-45'></div>
            </div>
          </div>
        )}

        <button
          onClick={() => setShowCategories(!showCategories)}
          className='md:hidden flex flex-col mx-auto text-white hover:text-yellow-light'>
          {showCategories ? (
            <svg
              className=' w-8 h-8 mx-auto'
              xmlns='http://www.w3.org/2000/svg'
              fill='none'
              viewBox='0 0 24 24'
              stroke='currentColor'>
              <path
                strokeLinecap='round'
                strokeLinejoin='round'
                strokeWidth={2}
                d='M5 11l7-7 7 7M5 19l7-7 7 7'
              />
            </svg>
          ) : (
            <svg
              className=' w-8 h-8 mx-auto'
              xmlns='http://www.w3.org/2000/svg'
              fill='none'
              viewBox='0 0 24 24'
              stroke='currentColor'>
              <path
                strokeLinecap='round'
                strokeLinejoin='round'
                strokeWidth={2}
                d='M19 13l-7 7-7-7m14-8l-7 7-7-7'
              />
            </svg>
          )}
          <span className='mx-auto header  pt-2'>
            {showCategories ? "Hide" : "Show"}
          </span>
        </button>
      </nav>
    </>
  );
};
